import MinimalHeader from './MinimalHeader';

export default MinimalHeader;
